module.exports = __webpack_public_path__ + "img/IND-i-2-IV.2fe49097.png";